module.exports = __webpack_public_path__ + "static/media/iconDashboardActive.0b50acac.svg";